import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-brand-black" data-id="element-126">
      <div className="max-w-3xl mx-auto" data-id="element-127">
        <div className="border-2 border-brand-gold rounded-2xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-128">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-32 bg-brand-gold/10 blur-3xl rounded-full" data-id="element-129" />

          <ShieldCheck className="w-20 h-20 text-brand-gold mx-auto mb-6 relative z-10" data-id="element-130" />

          <h2 className="font-heading text-3xl md:text-4xl font-bold text-brand-text mb-4 relative z-10" data-id="element-131">
            GARANTÍA POR INCONVENIENTES — 7 DÍAS
          </h2>
          <p className="text-brand-gold text-lg md:text-xl font-medium mb-8 relative z-10" data-id="element-132">
            Riesgo cero. Si tenés cualquier inconveniente, te devolvemos todo.
          </p>

          <div className="text-brand-muted text-base md:text-lg space-y-4 mb-8 relative z-10" data-id="element-133">
            <p data-id="element-134">Probá el sistema completo durante 7 días.</p>
            <p data-id="element-135">
              Aplicá los protocolos. Usá las tácticas. Practicá las técnicas.
            </p>
            <p data-id="element-136">
              Si durante los primeros 7 días tenés cualquier inconveniente con
              el material, el acceso o la descarga, escribinos y te devolvemos
              el 100% de tu dinero.
            </p>
            <p className="font-medium text-brand-text" data-id="element-137">
              Sin preguntas. Sin formularios. Sin esperas.
            </p>
          </div>

          <div className="h-px w-full max-w-xs mx-auto bg-gradient-to-r from-transparent via-brand-gold to-transparent mb-8 relative z-10" data-id="element-138" />

          <p className="font-heading text-xl text-brand-gold italic mb-8 relative z-10" data-id="element-139">
            "No tenés nada que perder. Solo el estatus que todavía no tenés."
          </p>

          <div className="flex flex-wrap justify-center gap-4 text-sm font-bold text-brand-text relative z-10" data-id="element-140">
            <span className="bg-brand-dark px-4 py-2 rounded-full border border-brand-gold/30" data-id="element-141">
              ✓ Devolución 100%
            </span>
            <span className="bg-brand-dark px-4 py-2 rounded-full border border-brand-gold/30" data-id="element-142">
              ✓ 7 días completos
            </span>
            <span className="bg-brand-dark px-4 py-2 rounded-full border border-brand-gold/30" data-id="element-143">
              ✓ Sin preguntas
            </span>
          </div>
        </div>
      </div>
    </section>;
}